import axiosInstance from '../axiosInstance';

export const getDashboardData = async () => {
  try {
    const response = await axiosInstance.get('/admin/dashboard');
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRecentNotifications = async () => {
  try {
    const response = await axiosInstance.get('/admin/last7days');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCandidateDashboardReport = async () => {
  try {
    const response = await axiosInstance.get('/admin/candidate-verification/dashboardReport');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCandidatesByStatus = async (status) => {
  try {
    const response = await axiosInstance.get(`/admin/status/${status}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getRecentCandidates = async () => {
  try {
    const response = axiosInstance.get('/admin/recent-candidates');

    return response;
  } catch (error) {
    throw error;
  }
};

export const getVerifiedCandidates = async () => {
  try {
    const response = await axiosInstance.get('/admin/verified-candidates');

    return response;
  } catch (error) {
    throw error;
  }
};

export const getClientList = async () => {
  try {
    const response = await axiosInstance.get('/admin/client/allClients');
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getAdminProfileByEmail = async (email) => {
  try {
    const response = await axiosInstance.get(`/admin/users/${email}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const createEmployee = async (formData) => {
  try {
    const payload = {
      username: formData.username,
      companyname: formData.companyname,
      phonenumber: formData.contactNumber,
      email: formData.email,
      password: formData.contactNumber,
      role: "EMPLOYEE",
      gender: formData.gender.toUpperCase(),
      dateOfBirth: formData.dateOfBirth,
    };

    const response = await axiosInstance.post('/admin/users/register', payload);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error('Something went wrong while adding employee.');
    }
  }
};


export const getActiveEmployees = async (
  page = 0,
  size = 1000,
  sortColumn = "candidateid",
  sort = false,
  search = ""
) => {
  try {
    const response = await axiosInstance.get('/admin/users/active-employees', {
      params: {
        pagenumber: page,
        pagesize: size,
        type: sortColumn,              
        asc: sort,
        search: search
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getInactiveEmployees = async (
  page,
  size,
  sortColumn,
  sort = false,
  search = ""
) => {
  try {
    const response = await axiosInstance.get(
      '/admin/users/inactive-employees',
      {
        params: {
          pagenumber: page,
          pagesize: size,
          type: sortColumn,          
          asc: sort,
          search: search    
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};


export const updateEmployee = async (userId, updatedData) => {
  try {
    const updatedBy = localStorage.getItem('user_email');
    const response = await axiosInstance.put(`/admin/users/${userId}`, updatedData, {
      headers: {
        'X-Updated-By': updatedBy,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};


export const changeUserStatus = async (id, status) => {
  try {
    const response = await axiosInstance.put(`/admin/users/${id}/changeStatus?status=${status}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteEmployee = (userId) => {
  return axiosInstance.delete(`/admin/users/${userId}`).then(res => res.data);
};

export const assignCandidateToEmployee = async (payload) => {
  const response = await axiosInstance.post('/admin/bgc-assignment/assign', payload);
  return response.data;
};

export const getAssignedCandidates = async (employeeId, pagenumber = 0,
  pagesize = 10,
  type = "candidateId",
  asc = false) => {
  try {
    const response = await axiosInstance.get(`/admin/bgc-assignment/assigned/${employeeId}`, {
      params: {
        pagenumber,
        pagesize,
        type,
        asc, // true = asc, false = desc
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getClientCandidates = async (clientEmail, page = 0, size = 10, type = "candidateid", asc = false, search = "") => {
  const res = await axiosInstance.get(`/admin/client/client-candidates`, {
    params: {
      clientEmail,
      page,
      size,
      type,
      asc,
      search
    }
  });
  return res.data;
};

export const getCandidateDetailsById = async (candidateId) => {
  try {
    const response = await axiosInstance.get(`/admin/candidates/info/${candidateId}`);
    return response.data?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCandidateReport = async (candidateId) => {
  try {
    const response = await axiosInstance.post(`/admin/candidate-verification/candidate-report/${candidateId}`);
    return response.data?.data;
  } catch (error) {
    throw error;
  }
};

export const submitVerificationResult = async (payload) => {
  try {
    // const response = await axiosInstance.post('/admin/candidate-verification/save', payload);
    const response = await axiosInstance.post('/admin/report/save-and-send-email', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};



// Admin / Client / Employee API
export const changePasswordAdmin = async (currentPassword, newPassword) => {
  try {
    const response = await axiosInstance.put(
      '/admin/users/change-password',
      {
        currentPassword,
        newPassword
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Candidate API
export const changePasswordCandidate = async (currentPassword, newPassword) => {
  try {
    const response = await axiosInstance.put(
      '/user/change-password',
      {
        currentPassword,
        newPassword
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 👇 SMART function used by your React component
export const changePassword = async (currentPassword, newPassword) => {
  const role = localStorage.getItem('user_role');

  if (!role) {
    throw new Error("User role not found. Please login again.");
  }

  // Candidate goes to candidate service
  if (role === 'CANDIDATE') {
    return changePasswordCandidate(currentPassword, newPassword);
  }

  // Admin, Client, Employee → admin service
  return changePasswordAdmin(currentPassword, newPassword);
};

export const registerClient = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/admin/users/client/register`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};



// export const fetchClientsByStatus = async (status) => {
//   try {
//     const response = await axiosInstance.get(
//       `/admin/users/status/${status}`
//     );
//     return response.data.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const fetchClientsByStatus = async (
  status,
  page = 0,
  itemsPerPage,
  sortBy = "createdAt",
  asc = false,
  searchTerm = ""
) => {
  const response = await axiosInstance.get(
    `/admin/users/status/${status}?page=${page}&size=${itemsPerPage}&asc=${asc}&type=${sortBy}&search=${searchTerm}`
  );
  return response.data;
};

export const approveClient = async (clientId) => {
  try {
    const response = await axiosInstance.put(
      `/admin/users/${clientId}/approve`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const rejectClient = async (clientId, reason) => {
  try {
    const response = await axiosInstance.put(
      `/admin/users/${clientId}/reject`,
      {
        reason: reason
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};


export const updateClientStatus = async (id, status) => {
  const res = await axiosInstance.put(`/admin/users/${id}/status?status=${status}`);
  return res.data;
};
export const deactivateClient = async (clientId) => {
  try {
    const response = await axiosInstance.put(
      `/admin/users/clients/${clientId}/deactivate`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBgvCases = async () => {
  try {
    const response = await axiosInstance.get('/admin/bgv-cases');

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const activateClient = async (clientId) => {
  try {
    const response = await axiosInstance.put(
      `/admin/users/clients/${clientId}/activate`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};